var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokCommentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 4.261 c -24.853 0 -45 15.715 -45 35.1 c 0 18.992 19.338 34.461 43.493 35.081 C 44.328 74.463 45 75.132 45 75.968 v 8.088 c 0 0.973 0.822 1.74 1.793 1.68 C 64.906 84.619 90 66.921 90 39.361 C 90 19.976 69.853 4.261 45 4.261 z M 27.086 42.229 c 0 0.874 -0.709 1.583 -1.583 1.583 h -4.835 c -0.874 0 -1.583 -0.709 -1.583 -1.583 v -4.835 c 0 -0.874 0.709 -1.583 1.583 -1.583 h 4.835 c 0.874 0 1.583 0.709 1.583 1.583 V 42.229 z M 49 42.229 c 0 0.874 -0.709 1.583 -1.583 1.583 h -4.835 c -0.874 0 -1.583 -0.709 -1.583 -1.583 v -4.835 c 0 -0.874 0.709 -1.583 1.583 -1.583 h 4.835 c 0.874 0 1.583 0.709 1.583 1.583 V 42.229 z M 70.914 42.229 c 0 0.874 -0.709 1.583 -1.583 1.583 h -4.835 c -0.874 0 -1.583 -0.709 -1.583 -1.583 v -4.835 c 0 -0.874 0.709 -1.583 1.583 -1.583 h 4.835 c 0.874 0 1.583 0.709 1.583 1.583 V 42.229 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokCommentWhite);
export default __webpack_public_path__ + "static/media/tiktok-comment-white.c16b611aeb442a5968e135fdeb634bb0.svg";
export { ForwardRef as ReactComponent };